import { IconsId } from "@silversea-ssc/design-system-icons";
import {
  BackgroundColor,
  SectionContainer,
  Icon,
  stringPresent,
  TextStyle,
  Slider
} from "@silversea-ssc/ui-components-react";
import { cardColorForBackground } from "components/PageBuilder/pageBuilderRenderHelper";
import React, { ReactElement } from "react";
import ShipFacilityCard from "./ShipFacilityCard";
import SubSectionTitle from "./SubSectionTitle";
import { AsCardFragment } from "types/graphql-types";

type ShipCardsSectionItem = {
  _key?: string;
  card?: AsCardFragment;
  codes?: (string | undefined)[];
};

type ShipCardsSectionProps = {
  icon: IconsId;
  title: string | ReactElement;
  backgroundColor: BackgroundColor;
  items: ShipCardsSectionItem[];
  openModal: (item: ShipCardsSectionItem) => void;
  dataContentName: string;
  shipNotReadyDisclaimer?: string;
};

const ShipCardsSection: React.FC<ShipCardsSectionProps> = ({
  icon,
  title,
  backgroundColor,
  items = [],
  openModal,
  dataContentName,
  shipNotReadyDisclaimer
}) => {
  const inverseColor = cardColorForBackground(backgroundColor);

  return (
    <SectionContainer
      spacingTop="compact"
      spacingBottom="compact"
      backgroundColor={backgroundColor}
      dataContentName={dataContentName}
    >
      <SubSectionTitle>
        <Icon name={icon} size="2x" padding="inline" /> {title}
        {stringPresent(shipNotReadyDisclaimer) && (
          <TextStyle textAlign="center" fontSize="small" fontSizeResponsive>
            <React.Fragment>{shipNotReadyDisclaimer}</React.Fragment>
          </TextStyle>
        )}
      </SubSectionTitle>

      <Slider variantColor={inverseColor}>
        {items?.map((item) => {
          if (!item.card) return null;
          return (
            <ShipFacilityCard
              key={item._key}
              card={item.card}
              backgroundColor={inverseColor}
              openModal={() => openModal(item)}
            />
          );
        })}
      </Slider>
    </SectionContainer>
  );
};

export default ShipCardsSection;
